function Link({
  className,
  color = 'currentColor',
}: {
  className?: string
  color?: string
}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <g fill="none" fillRule="evenodd">
        <path fill="none" d="M0 0h32v32H0z" />
        <path
          fill={color}
          d="M10.898 11.584a3.834 3.834 0 0 1 5.422 0l1.3 1.298a3.84 3.84 0 0 1 .66 4.532c-.077.146-.28.167-.398.051l-1.152-1.152a.248.248 0 0 1-.059-.24 1.828 1.828 0 0 0-.467-1.777l-1.298-1.298a1.835 1.835 0 0 0-2.594 0l-5.775 5.776a1.832 1.832 0 0 0 0 2.593l1.297 1.298a1.836 1.836 0 0 0 2.595 0l3.321-3.322a.25.25 0 0 1 .354 0l1.061 1.062a.25.25 0 0 1 0 .353l-3.323 3.321a3.833 3.833 0 0 1-5.422 0l-1.297-1.297a3.834 3.834 0 0 1 0-5.423zm9.37-4.46a3.835 3.835 0 0 1 5.424 0L26.99 8.42a3.836 3.836 0 0 1 0 5.423l-5.774 5.775a3.837 3.837 0 0 1-5.424 0l-1.298-1.298a3.832 3.832 0 0 1-.683-4.474c.077-.148.283-.171.4-.053l1.163 1.163c.061.06.082.149.061.234a1.82 1.82 0 0 0 .473 1.716l1.298 1.298a1.837 1.837 0 0 0 2.596 0l5.773-5.775a1.834 1.834 0 0 0 0-2.595l-1.297-1.297a1.834 1.834 0 0 0-2.595 0l-3.359 3.358a.25.25 0 0 1-.354 0l-1.06-1.06a.25.25 0 0 1 0-.354z"
        />
      </g>
    </svg>
  )
}

export default Link
